import { render, staticRenderFns } from "./CustomToggle.vue?vue&type=template&id=5d230c4a&"
import script from "./CustomToggle.vue?vue&type=script&lang=js&"
export * from "./CustomToggle.vue?vue&type=script&lang=js&"
import style0 from "./CustomToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports